import React from "react";
import ComingSoonSpecialForYou from "./components/Coming Soon & Random/ComingSoonSpecialForYou";
import HomeHeader from "../components/Nav & Header/HomeHeader";
import TopCategories from "./components/Tags & Tag/TopCategories.jsx";
import NovelsPagination from "./components/Pagination Novels/NovelsPagination";
import NewNovels from "./components/Recent Novels/NewNovels";
import CommentsSlider from "./components/Comments/CommentsSlider";
import { Helmet } from "react-helmet";

function Home({ setInterfaces, setPopUp }) {
  return (
    <div>
      <Helmet>
        {/* <!-- Primary Meta Tags --> */}
        <title>EyeNovel | Read Free Online Novels in Your Favor</title>
        <meta
          name="title"
          content="EyeNovel | Read Free Online Novels in Your Favor"
        />
        <meta
          name="description"
          content="EyeNovel - The best web novels community in the world. Online Reading stories, fiction books, novels and comic books!"
        />

        {/* <!-- Open Graph / Facebook --> */}
        <meta property="og:type" content="website" />
        <meta property="og:url" content="https://eyenovel.netlify.app/" />
        <meta
          property="og:title"
          content="EyeNovel | Read Free Online Novels in Your Favor"
        />
        <meta
          property="og:description"
          content="EyeNovel - The best web novels community in the world. Online Reading stories, fiction books, novels and comic books!"
        />
        <meta
          property="og:image"
          content={`https://img.gs/bfcwxjcwhk/full,quality=medium/https://eyenovel.netlify.app/images/overview1.png`}
        />

        {/* <!-- Twitter --> */}
        <meta property="twitter:card" content="summary_large_image" />
        <meta property="twitter:url" content="https://eyenovel.netlify.app/" />
        <meta
          property="twitter:title"
          content="EyeNovel | Read Free Online Novels in Your Favor"
        />
        <meta
          property="twitter:description"
          content="EyeNovel - The best web novels community in the world. Online Reading stories, fiction books, novels and comic books!"
        />
        <meta
          property="twitter:image"
          content={`https://img.gs/bfcwxjcwhk/full,quality=medium/https://eyenovel.netlify.app/images/overview1.png`}
        />
        <meta name="author" content="Osama Daimallah" />
      </Helmet>
      <HomeHeader />
      <TopCategories />
      <NovelsPagination />
      <NewNovels />
      <ComingSoonSpecialForYou
        setInterfaces={setInterfaces}
        setPopUp={setPopUp}
      />
      <CommentsSlider />
    </div>
  );
}

export default Home;
